<template>
	<div class="faset date-range-container">
		<CustomDatePicker
			v-if="rendered"
			:defaultDate="defaultStart"
			@onSelect="updateStart"
			:title="'Enter a start date in the format MM/DD/YYYY'"
			:minDate="minDate"
			:maxDate="selected.end"
			:container="singleContainer"
			:yearRange="yearRange"
			:disableWeekends="disableWeekends"
			:disableVgHolidays="disableVgHolidays"
		/>
		<CustomDatePicker
			v-if="rendered"
			:defaultDate="defaultEnd"
			:minDate="selected.start"
			:maxDate="maxDate"
			@onSelect="updateEnd"
			:title="'Enter an end date in the format MM/DD/YYYY'"
			:container="singleContainer"
			:yearRange="yearRange"
			:disableWeekends="disableWeekends"
			:disableVgHolidays="disableVgHolidays"
		/>
		<div class="datepicker__renderTo" ref="container" />
	</div>
</template>

<script>
/**
 * Component that holds 2 of our custom date pickers
 */
import CustomDatePicker from "../custom-date-picker/CustomDatePicker";
import moment from "moment";
const today = new Date();

export default {
	name: "DateRangePicker",
	components: {
		CustomDatePicker
	},
	props: {
		/**
		 * Setting YTD start date of Jan 1 of current year
		 */
		defaultStart: {
			type: Date,
			default: function () {
				return new Date(today.getFullYear(), 0, 1);
			}
		},
		/**
		 * YTD end date: always default to today
		 */
		defaultEnd: {
			type: Date,
			default: function () {
				return today;
			}
		},
		/**
		 * Sets the min date of the end range (right side datepicker) so that
		 * you can't choose an earlier date then the starting range (left side)
		 */
		minDate: {
			type: Date,
			default: function () {
				return moment("1924-01-01").toDate();
			}
		},
		/**
		 * sets the max date of the start range (left side datepicker) so that
		 * you can't choose a later date than the end range (right side)
		 */
		maxDate: {
			type: Date,
			default: function () {
				return today;
			}
		},
		/**
		 *  disallow selection of Saturdays or Sundays
		 */
		disableWeekends: {
			default: false,
			type: Boolean
		},
		/**
		 *  disallow selection of Vanguard's US Holidays
		 */
		disableVgHolidays: {
			default: false,
			type: Boolean
		},
		/**
		 * Function to execute when you choose a date in either calendar
		 * it will get passed the full selected object with {start,end} keys
		 */
		onSelect: Function
	},
	data() {
		return {
			selected: {
				start: moment(today).subtract(10, "years").toDate(),
				end: today
			},
			singleContainer: null,
			rendered: false,
			yearRange: [today.getFullYear() - 10, today.getFullYear()]
		};
	},
	mounted() {
		this.singleContainer = this.$refs.container;
		this.rendered = true;
		this.$nextTick(function () {
			this.selected = {
				start: this.defaultStart,
				end: this.defaultEnd
			};
		});
	},
	methods: {
		updateStart(newdate) {
			if (moment(newdate).isBefore(this.minDate)) {
				// prevent going earlier than the min date
				this.selected.start = this.minDate;
			} else if (moment(newdate).isAfter(this.selected.end)) {
				// prevent start date from going past the selected end date
				this.selected.start = this.selected.end;
			} else {
				this.selected.start = newdate;
			}

			if (typeof this.onSelect === "function") {
				this.onSelect(this.selected);
			}
		},
		updateEnd(newdate) {
			if (moment(newdate).isAfter(this.maxDate)) {
				// prevent going later than the max date
				this.selected.end = this.maxDate;
			} else if (moment(newdate).isBefore(this.selected.start)) {
				// prevent the end date from going earliar than the selected start date
				this.selected.end = this.selected.start;
			} else {
				this.selected.end = newdate;
			}

			if (typeof this.onSelect === "function") {
				this.onSelect(this.selected);
			}
		}
	}
};
</script>

<style lang="scss">
.faset.date-range-container {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	position: relative;
	margin-top: 24px;
	margin-bottom: 24px;

	@include to-md {
		.datepicker__container {
			width: 50%;
		}
	}

	.datepicker__container:nth-child(2) {
		margin-left: -1px;
	}

	.datepicker__renderTo {
		left: 0;
		top: 100%;
	}
}
</style>
